<template>
  <div>
    <v-container fluid>
      <base-material-card
        icon="mdi-account-star"
        :title="
          'รับรายงานตัว ผู้ได้รับการบรรจุ ตำแหน่ง ผู้อำนวยการสถานศึกษา ครั้งที่ : ' +
            (period.times || '-') +
            ' ปี : ' +
            (period.year || '-')
        "
      >
        <v-alert
          v-if="period.is_open"
          type="success"
          border="left"
          colored-border
          elevation="1"
        >
          <div class="d-flex align-center flex-wrap">
            <div class="mr-auto">
              <div class="font-weight-bold">เปิดรับรายงานตัว</div>
              <div>
                {{ formatDateTH(period.start) }} ถึง
                {{ formatDateTH(period.stop) }} เวลา 16.30 น.
                — บันทึก แก้ไข หรือยกเลิกการรายงานตัวได้จนถึงเวลาปิดระบบ
              </div>
            </div>
            <v-chip color="error" dark class="mt-1">
              <v-icon left small>mdi-timer-sand</v-icon>
              เหลือเวลา {{ remainingText }}
            </v-chip>
          </div>
        </v-alert>
        <v-alert
          v-else-if="period.enable"
          type="warning"
          border="left"
          colored-border
          elevation="1"
        >
          อยู่นอกกำหนดการรับรายงานตัว ({{ formatDateTH(period.start) }} ถึง
          {{ formatDateTH(period.stop) }} เวลา 16.30 น.) ดูข้อมูลได้อย่างเดียว
        </v-alert>
        <v-alert v-else-if="loaded" type="info" border="left" colored-border>
          ยังไม่มีกำหนดการรับรายงานตัว ตำแหน่ง ผู้อำนวยการสถานศึกษา
        </v-alert>

        <v-row dense class="mb-2">
          <v-col cols="6" md="3">
            <v-card outlined class="pa-3 text-center">
              <div class="caption grey--text">ผู้ได้รับการบรรจุ</div>
              <div class="text-h5 font-weight-bold">{{ counts.all }}</div>
            </v-card>
          </v-col>
          <v-col cols="6" md="3">
            <v-card outlined class="pa-3 text-center">
              <div class="caption grey--text">มารายงานตัว</div>
              <div class="text-h5 font-weight-bold success--text">
                {{ counts.receipt }}
              </div>
            </v-card>
          </v-col>
          <v-col cols="6" md="3">
            <v-card outlined class="pa-3 text-center">
              <div class="caption grey--text">ไม่มารายงานตัว</div>
              <div class="text-h5 font-weight-bold error--text">
                {{ counts.missing }}
              </div>
            </v-card>
          </v-col>
          <v-col cols="6" md="3">
            <v-card outlined class="pa-3 text-center">
              <div class="caption grey--text">รอดำเนินการ</div>
              <div class="text-h5 font-weight-bold warning--text">
                {{ counts.pending }}
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="rows"
          item-key="sedirector_app_idref"
          :items-per-page="-1"
          hide-default-footer
          no-data-text="ไม่มีผู้ได้รับการบรรจุ ตำแหน่ง ผู้อำนวยการ ที่สถานศึกษาของท่าน"
        >
          <template v-slot:item.fristnames="{ item }">
            <div class="font-weight-bold">{{ item.fristnames }}</div>
            <div class="caption grey--text">
              {{ item.sedirector_app_idcard }}
              <span v-if="item.tel_p"> • โทร {{ item.tel_p }}</span>
            </div>
          </template>
          <template v-slot:item.college_name_old="{ item }">
            <div>{{ item.college_name_old || item.sedirector_app_college }}</div>
            <div class="caption grey--text">
              ตำแหน่งเลขที่ {{ item.id_position_old || "-" }}
            </div>
          </template>
          <template v-slot:item.sedirector_app_college_report="{ item }">
            <v-chip
              v-if="item.sedirector_app_college_report === 'receipt'"
              color="success"
              dark
              small
              >มารายงานตัว</v-chip
            >
            <v-chip
              v-else-if="item.sedirector_app_college_report === 'missing'"
              color="error"
              dark
              small
              >ไม่มารายงานตัว</v-chip
            >
            <v-chip v-else color="warning" small>รอรายงานตัว</v-chip>
            <div
              v-if="item.sedirector_app_college_datetime"
              class="caption grey--text"
            >
              {{ item.sedirector_app_college_datetime }}
            </div>
          </template>
          <template v-slot:item.sedirector_app_college_filereport="{ item }">
            <v-btn
              v-if="item.sedirector_app_college_filereport"
              small
              fab
              color="info"
              @click="viewPdf(item.sedirector_app_college_filereport)"
              ><v-icon>mdi-file-pdf-box</v-icon></v-btn
            >
            <span v-else>-</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <template v-if="period.is_open">
              <v-btn
                v-if="!item.sedirector_app_college_report"
                rounded
                small
                color="warning"
                @click="openReport(item)"
                ><v-icon small left>mdi-email</v-icon>รับรายงานตัว</v-btn
              >
              <template v-else>
                <v-btn
                  rounded
                  small
                  color="primary"
                  class="mr-1"
                  @click="openReport(item)"
                  ><v-icon small left>mdi-pencil</v-icon>แก้ไข</v-btn
                >
                <v-btn
                  rounded
                  small
                  outlined
                  color="error"
                  @click="cancelReport(item)"
                  ><v-icon small left>mdi-close</v-icon>ยกเลิก</v-btn
                >
              </template>
            </template>
            <v-chip v-else small color="grey" dark>
              <v-icon small left>mdi-lock</v-icon>ปิดระบบ
            </v-chip>
          </template>
        </v-data-table>
      </base-material-card>

      <!-- บันทึก/แก้ไขการรับรายงานตัว -->
      <v-dialog v-model="reportDialog" persistent max-width="640">
        <v-card>
          <v-card-title class="warning white--text">
            <v-icon dark class="mr-2">mdi-email-open</v-icon>
            รับรายงานตัว ตำแหน่ง ผู้อำนวยการสถานศึกษา
          </v-card-title>
          <v-card-text class="pt-4">
            <v-list dense>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>ชื่อ-นามสกุล</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold">{{
                    editItem.fristnames
                  }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-content>
                  <v-list-item-subtitle>ตำแหน่งเลขที่ที่บรรจุ</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold">{{
                    editItem.sedirector_app_collegeapp_idpositions
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>สถานศึกษาเดิม</v-list-item-subtitle>
                  <v-list-item-title>{{
                    editItem.college_name_old
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-form ref="reportForm" lazy-validation>
              <v-radio-group
                v-model="form.report"
                row
                :rules="[v => !!v || 'กรุณาเลือกสถานะ']"
              >
                <v-radio label="มารายงานตัว" value="receipt" color="success" />
                <v-radio label="ไม่มารายงานตัว" value="missing" color="error" />
              </v-radio-group>
              <v-file-input
                v-model="form.file"
                accept=".pdf,application/pdf"
                outlined
                dense
                show-size
                prepend-icon="mdi-file-pdf-box"
                :label="
                  editItem.sedirector_app_college_filereport
                    ? 'แนบหนังสือนำส่งใหม่ (ไม่แนบ = ใช้ไฟล์เดิม)'
                    : 'หนังสือนำส่ง / แจ้งผลรับรายงานตัว (.pdf)'
                "
                :rules="fileRules"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text :disabled="saving" @click="reportDialog = false"
              >ปิด</v-btn
            >
            <v-btn color="warning" :loading="saving" @click="saveReport()"
              ><v-icon left>mdi-content-save</v-icon>บันทึก</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="pdfDialog" max-width="80%">
        <v-card>
          <embed :src="'/HrvecRegisDir/' + pdfFile" width="100%" height="700px" />
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
const MAX_FILE = 10 * 1024 * 1024;

export default {
  name: "CollegeDirectorAppReport",
  data() {
    return {
      ApiKey: "HRvec2021",
      loading: false,
      loaded: false,
      saving: false,
      period: {},
      rows: [],
      headers: [
        { text: "ลำดับที่", value: "sedirector_app_idnoaccount", align: "center" },
        { text: "ชื่อ-นามสกุล", value: "fristnames" },
        { text: "สถานศึกษาเดิม", value: "college_name_old" },
        {
          text: "ตำแหน่งเลขที่ที่บรรจุ",
          value: "sedirector_app_collegeapp_idpositions",
          align: "center"
        },
        { text: "สถานะ", value: "sedirector_app_college_report", align: "center" },
        {
          text: "หนังสือนำส่ง",
          value: "sedirector_app_college_filereport",
          align: "center",
          sortable: false
        },
        { text: "ดำเนินการ", value: "actions", align: "center", sortable: false }
      ],
      reportDialog: false,
      editItem: {},
      form: { report: null, file: null },
      pdfDialog: false,
      pdfFile: "",
      clockOffset: 0,
      nowTick: Date.now(),
      timer: null
    };
  },
  computed: {
    counts() {
      const c = { all: this.rows.length, receipt: 0, missing: 0, pending: 0 };
      this.rows.forEach(r => {
        if (r.sedirector_app_college_report === "receipt") c.receipt++;
        else if (r.sedirector_app_college_report === "missing") c.missing++;
        else c.pending++;
      });
      return c;
    },
    // นับถอยหลังด้วยเวลาเซิร์ฟเวอร์ (clockOffset) ไม่พึ่งนาฬิกาเครื่องผู้ใช้
    remainingText() {
      if (!this.period.close_at) return "-";
      const close = new Date(this.period.close_at.replace(" ", "T")).getTime();
      let ms = close - (this.nowTick + this.clockOffset);
      if (ms <= 0) return "ปิดระบบแล้ว";
      const d = Math.floor(ms / 86400000);
      ms %= 86400000;
      const h = Math.floor(ms / 3600000);
      ms %= 3600000;
      const m = Math.floor(ms / 60000);
      return (d ? d + " วัน " : "") + h + " ชม. " + m + " นาที";
    },
    fileRules() {
      const needFile = !this.editItem.sedirector_app_college_filereport;
      return [
        v => !needFile || !!v || "กรุณาแนบไฟล์ PDF",
        v => !v || v.size <= MAX_FILE || "ไฟล์ไม่เกิน 10 MB"
      ];
    }
  },
  async mounted() {
    await this.load();
    this.timer = setInterval(() => {
      this.nowTick = Date.now();
      // ถึงเวลาปิดขณะเปิดหน้าอยู่ → โหลดใหม่เพื่อล็อกปุ่ม (เซิร์ฟเวอร์ก็ปฏิเสธอยู่แล้ว)
      if (this.period.is_open && this.remainingText === "ปิดระบบแล้ว") this.load();
    }, 30000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    async post(payload) {
      try {
        const result = await this.$http.post("director_app_college_report.php", payload);
        return result.data;
      } catch (e) {
        const data = (e.response && e.response.data) || {};
        return { status: false, message: data.message || "เชื่อมต่อระบบไม่สำเร็จ" };
      }
    },

    async load() {
      this.loading = true;
      const data = await this.post({ ApiKey: this.ApiKey, action: "list" });
      this.loading = false;
      this.loaded = true;
      if (!data.status) {
        Swal.fire({ icon: "error", title: data.message || "โหลดข้อมูลไม่สำเร็จ" });
        return;
      }
      this.period = data.period || {};
      this.rows = data.rows || [];
      if (this.period.server_time) {
        this.clockOffset =
          new Date(this.period.server_time.replace(" ", "T")).getTime() - Date.now();
      }
      this.nowTick = Date.now();
    },

    formatDateTH(value) {
      if (!value) return "-";
      const d = new Date(value);
      if (isNaN(d)) return value;
      return d.toLocaleDateString("th-TH", {
        day: "numeric",
        month: "long",
        year: "numeric"
      });
    },

    viewPdf(file) {
      this.pdfFile = file;
      this.pdfDialog = true;
    },

    openReport(item) {
      this.editItem = Object.assign({}, item);
      this.form = { report: item.sedirector_app_college_report || null, file: null };
      this.reportDialog = true;
      this.$nextTick(() => this.$refs.reportForm && this.$refs.reportForm.resetValidation());
    },

    async saveReport() {
      if (!this.$refs.reportForm.validate()) return;
      const fd = new FormData();
      fd.append("ApiKey", this.ApiKey);
      fd.append("action", "save");
      fd.append("sedirector_app_idref", this.editItem.sedirector_app_idref);
      fd.append("sedirector_app_college_report", this.form.report);
      if (this.form.file) fd.append("file", this.form.file);

      this.saving = true;
      const data = await this.post(fd);
      this.saving = false;
      if (data.status) {
        this.reportDialog = false;
        Swal.fire({
          icon: "success",
          title: data.message,
          showConfirmButton: false,
          timer: 1500
        });
      } else {
        Swal.fire({ icon: "warning", title: data.message || "บันทึกไม่สำเร็จ" });
      }
      await this.load();
    },

    async cancelReport(item) {
      const confirm = await Swal.fire({
        title: "ยกเลิกการรายงานตัว ?",
        text: item.fristnames + " จะกลับเป็นสถานะรอรายงานตัว",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b3151b",
        confirmButtonText: "ยกเลิกการรายงานตัว",
        cancelButtonText: "ปิด"
      });
      if (!confirm.isConfirmed) return;
      const data = await this.post({
        ApiKey: this.ApiKey,
        action: "cancel",
        sedirector_app_idref: item.sedirector_app_idref
      });
      Swal.fire({
        icon: data.status ? "success" : "warning",
        title: data.message || "ดำเนินการไม่สำเร็จ",
        showConfirmButton: !data.status,
        timer: data.status ? 1500 : undefined
      });
      await this.load();
    }
  }
};
</script>
